export default __webpack_public_path__ + "static/media/vbv_mcsc_logo.687bd9c4.png";